export default __webpack_public_path__ + "static/media/ribs.6f2ea8a2.svg";